<div [ngClass]="maxWidth" class="mx-auto" data-test-id="rich-text">
	@if (isReadMore) {
		<vp-read-more>
			<ng-container [ngTemplateOutlet]="richText" />
		</vp-read-more>
	} @else {
		<ng-container [ngTemplateOutlet]="richText" />
	}
</div>

<ng-template #richText>
	<div
		[class]="listStyle"
		[editableInStoryblok]="_editable()"
		[innerHTML]="renderedRichText()"
		class="richtext"
	></div>
</ng-template>
